// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2WpUe","bigColWidth":"Table_bigColWidth__25poQ","biggerColWidth":"Table_biggerColWidth__1XvNK","row":"Table_row__hE44p","col":"Table_col__3xF1d"};